<template>
  <el-table
    :data="packTypes"
    max-height="250"
    style="width: 100%"
    v-loading="loading"
    :default-sort="{prop: 'name', order: 'ascending'}"
  >
    <el-table-column
      prop="name"
      label="Név"
    />
    <el-table-column
      fixed="right"
      label=""
      width="120"
    >
      <template slot-scope="scope">
        <Actions :packType="scope.row" />
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
  import Actions from './Actions'

  export default {

    components: {
      Actions
    },

    computed: {
      packTypes() {
        return this.$store.getters['packType/packTypes'];
      },

      loading() {
        return this.$store.getters['packType/loading'];
      }
    },

    async mounted() {
      await this.$store.dispatch('packType/fetchAll');
    },
  }
</script>
